var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C3.90434 0 3.81465 0.0159035 3.73094 0.0477099C3.64723 0.0795164 3.56951 0.133588 3.49776 0.209924L0.197309 3.72137C0.0657698 3.86132 0 4.03944 0 4.25573C0 4.47201 0.0657698 4.65013 0.197309 4.79008C0.328849 4.93003 0.496263 5 0.699552 5C0.90284 5 1.07025 4.93003 1.20179 4.79008L4 1.81298L6.79821 4.79008C6.92975 4.93003 7.09716 5 7.30045 5C7.50374 5 7.67115 4.93003 7.80269 4.79008C7.93423 4.65013 8 4.47201 8 4.25573C8 4.03944 7.93423 3.86132 7.80269 3.72137L4.50224 0.209924C4.43049 0.133588 4.35277 0.0795164 4.26906 0.0477099C4.18535 0.0159035 4.09567 0 4 0Z",
    fill: "#27282B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.9c7492fd54010986f30a6cd80f09f89c.svg";
export { ForwardRef as ReactComponent };